import { galleryCategories, navLinks } from "@/mocks/gallery";

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center text-background-50">
                <i className="ri-image-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">年轻的岳母</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-300 max-w-sm">
              一个专注整理「年轻的岳母」相关图片资源的单页浏览站，涵盖高清写真、日常自拍、室内人像、户外旅拍与壁纸素材，按主题分区呈现，方便快速定位与收藏。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">页面导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a href={`#${link.id}`} className="text-sm text-secondary-300 hover:text-primary-300 transition-colors cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-background-50">主题分类</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {galleryCategories
                .filter((cat) => cat.id !== "all")
                .map((cat) => (
                  <li key={cat.id}>
                    <a href="#categories" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors cursor-pointer">
                      {cat.label}
                    </a>
                  </li>
                ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            © {new Date().getFullYear()} 年轻的岳母图片浏览站 · 内容仅作图片资源整理与浏览展示
          </p>
          <p className="text-xs text-secondary-400">
            所有图片均为示例素材，用于页面排版与浏览演示。
          </p>
        </div>
      </div>
    </footer>
  );
}